import { getStrapiBaseUrl, getWithLocaleFallback } from "../../services/strapiApi";

// Fonction pour récupérer les données de la page News
export const getNewsPageData = async (locale) => {
  return getWithLocaleFallback(
    "/news-page?populate[heroComponent][populate]=*&populate[stats]=*&populate[pressKitSection]=*",
    { locale, fallbackLocale: 'fr' }
  );
};

// Fonction pour récupérer les articles de news
export const getNewsDescriptions = async (locale) => {
  return getWithLocaleFallback("/news-descriotions?populate=*", { locale, fallbackLocale: 'fr' });
};

// Fonction pour récupérer un article de news spécifique par ID
export const getNewsById = async (id, locale) => {
  return getWithLocaleFallback(`/news-descriotions/${id}?populate=*`, { locale, fallbackLocale: 'fr' });
};

// Fonction pour récupérer un article de news spécifique par slug
export const getNewsBySlug = async (slug, locale) => {
  const result = await getWithLocaleFallback(
    `/news-descriotions?filters[slug][$eq]=${slug}&populate=*`,
    { locale, fallbackLocale: 'fr' }
  );

  if (!result.ok) {
    return result;
  }

  const item = Array.isArray(result.data) ? result.data[0] : null;
  if (!item) {
    return {
      ok: false,
      reason: "NOT_FOUND",
      status: result.status,
      data: null,
      error: null,
    };
  }

  return { ...result, data: item };
};

// Fonction pour formater les donnÃ©es de la page News
export const formatNewsPageData = (strapiData) => {
  if (!strapiData) {
    return {
      id: null,
      title: "",
      heroComponent: {
        title: "",
        description: "",
        image: "",
      },
      stats: [],
      pressKitSection: {
        title: "",
        description: "",
      },
    };
  }

  // Handle both cases: strapiData with attributes or strapiData as attributes directly
  const attributes = strapiData.attributes || strapiData;

  // Extract image URL with multiple fallback strategies
  let heroImageUrl = "";
  if (attributes.heroComponent?.image?.data?.attributes?.url) {
    const imageUrl = attributes.heroComponent.image.data.attributes.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  } else if (attributes.heroComponent?.image?.data?.url) {
    const imageUrl = attributes.heroComponent.image.data.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  } else if (attributes.heroComponent?.image?.url) {
    const imageUrl = attributes.heroComponent.image.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  }

  return {
    id: strapiData.id,
    title: attributes.title || "",
    heroComponent: {
      title: attributes.heroComponent?.title || "",
      description: attributes.heroComponent?.description || "",
      image: heroImageUrl,
    },
    stats:
      attributes.stats?.data?.map((stat) => ({
        id: stat?.id,
        value: stat?.value || "",
        label: stat?.title || "",
      })) || [],
    pressKitSection: {
      title: attributes.pressKitSection?.title || "",
      description: attributes.pressKitSection?.description || "",
    },
  };
};

// Fonction pour formater un seul article de news (pour la page de dÃ©tail)
export const formatSingleNews = (newsItem) => {
  if (!newsItem) {
    return null;
  }

  const attributes = newsItem.attributes || newsItem;

  // Extract image URL with multiple fallback strategies (Image, image, etc.)
  let imageUrl = "";
  if (attributes.Image?.data?.attributes?.url) {
    const url = attributes.Image.data.attributes.url;
    imageUrl = url.startsWith("http")
      ? url
      : `${getStrapiBaseUrl()}${url}`;
  } else if (attributes.Image?.data?.url) {
    const url = attributes.Image.data.url;
    imageUrl = url.startsWith("http")
      ? url
      : `${getStrapiBaseUrl()}${url}`;
  } else if (attributes.Image?.url) {
    const url = attributes.Image.url;
    imageUrl = url.startsWith("http")
      ? url
      : `${getStrapiBaseUrl()}${url}`;
  } else if (attributes.image?.data?.attributes?.url) {
    const url = attributes.image.data.attributes.url;
    imageUrl = url.startsWith("http")
      ? url
      : `${getStrapiBaseUrl()}${url}`;
  } else if (attributes.image?.data?.url) {
    const url = attributes.image.data.url;
    imageUrl = url.startsWith("http")
      ? url
      : `${getStrapiBaseUrl()}${url}`;
  } else if (attributes.image?.url) {
    const url = attributes.image.url;
    imageUrl = url.startsWith("http")
      ? url
      : `${getStrapiBaseUrl()}${url}`;
  }

  // Extract content from structured content field (using 'description' as content if 'content' is not available)
  let content = "";
  if (Array.isArray(attributes.content)) {
    content = attributes.content
      .map((block) => {
        if (block.type === "paragraph" && block.children) {
          return `<p>${block.children
            .map((child) => child.text || "")
            .join(" ")}</p>`;
        } else if (block.type === "heading" && block.children) {
          const level = block.level || 2;
          return `<h${level}>${block.children
            .map((child) => child.text || "")
            .join(" ")}</h${level}>`;
        } else if (block.type === "list" && block.children) {
          const listType = block.format === "ordered" ? "ol" : "ul";
          const items = block.children
            .filter((child) => child.children)
            .map(
              (child) =>
                `<li>${child.children
                  .map((grandChild) => grandChild.text || "")
                  .join(" ")}</li>`
            )
            .join("");
          return `<${listType}>${items}</${listType}>`;
        }
        return block.children
          ? block.children.map((child) => child.text || "").join(" ")
          : "";
      })
      .join("");
  } else if (Array.isArray(attributes.description)) {
    content = attributes.description
      .map((block) => {
        if (block.type === "paragraph" && block.children) {
          let text = block.children
            .map((child) => child.text || "")
            .join(" ");
          if (block.children.some((child) => child.bold)) {
            text = block.children
              .map((child) => {
                if (child.bold) {
                  return `<strong>${child.text || ""}</strong>`;
                }
                return child.text || "";
              })
              .join(" ");
          }
          return `<p>${text}</p>`;
        } else if (block.type === "heading" && block.children) {
          const level = block.level || 2;
          return `<h${level}>${block.children
            .map((child) => child.text || "")
            .join(" ")}</h${level}>`;
        } else if (block.type === "list" && block.children) {
          const listType = block.format === "ordered" ? "ol" : "ul";
          const items = block.children
            .filter((child) => child.children)
            .map(
              (child) =>
                `<li>${child.children
                  .map((grandChild) => grandChild.text || "")
                  .join(" ")}</li>`
            )
            .join("");
          return `<${listType}>${items}</${listType}>`;
        }
        return block.children
          ? block.children.map((child) => child.text || "").join(" ")
          : "";
      })
      .join("");
  } else {
    content = attributes.content || attributes.body || "";
  }

  // Extract excerpt from description field (structured content)
  let excerpt = "";
  if (Array.isArray(attributes.description)) {
    const firstTwoBlocks = attributes.description.slice(0, 2);
    excerpt =
      firstTwoBlocks
        .map((block) =>
          block.children
            ? block.children.map((child) => child.text || "").join(" ")
            : ""
        )
        .join(" ")
        .substring(0, 160) + "...";
  } else {
    excerpt = attributes.description || attributes.excerpt || attributes.body || "";
  }

  // Extract author information
  const author = attributes.author?.data?.attributes || {
    name: "Admin",
    role: "Editor",
    avatar: "https://via.placeholder.com/150",
  };

  // Extract tags
  let tags = [];
  if (attributes.tags?.data) {
    tags = attributes.tags.data.map(
      (tag) => tag.attributes?.name || tag.name || ""
    );
  } else if (Array.isArray(attributes.tags)) {
    tags = attributes.tags;
  } else if (attributes.tagList) {
    tags = Array.isArray(attributes.tagList) ? attributes.tagList : [];
  } else {
    tags = [attributes.category].filter(Boolean);
  }

  return {
    id: newsItem.id,
    title: attributes.Title || attributes.title || attributes.name || "",
    content,
    excerpt,
    image: imageUrl,
    date: attributes.date || attributes.publishedAt || attributes.createdAt || "",
    category:
      attributes.category ||
      attributes.categories?.data?.[0]?.attributes?.name ||
      "News",
    author: {
      name: author.name || "Admin",
      role: author.role || "Editor",
      avatar: author.avatar || "https://via.placeholder.com/150",
    },
    readTime: attributes.readTime || calculateReadingTime(content),
    views: attributes.views || "2,847",
    slug: attributes.slug || attributes.documentId || newsItem.id?.toString() || "",
    tags,
  };
};

// Helper function to calculate reading time
const calculateReadingTime = (text) => {
  if (!text) return "1 min read";

  const plainText = text.replace(/<[^>]*>/g, " ");
  const wordsPerMinute = 200;
  const wordCount = plainText
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length;
  const readingTimeInMinutes = Math.ceil(wordCount / wordsPerMinute);

  return `${readingTimeInMinutes} min read`;
};

// Fonction pour formater les articles de news
export const formatNewsDescriptions = (newsData) => {
  if (!Array.isArray(newsData)) {
    newsData = [newsData];
  }

  return newsData.map((item) => {
    const attributes = item.attributes || item;

    let imageUrl = "";
    if (attributes.Image?.data?.attributes?.url) {
      const url = attributes.Image.data.attributes.url;
      imageUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (attributes.Image?.data?.url) {
      const url = attributes.Image.data.url;
      imageUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (attributes.Image?.url) {
      const url = attributes.Image.url;
      imageUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (attributes.image?.data?.attributes?.url) {
      const url = attributes.image.data.attributes.url;
      imageUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (attributes.image?.data?.url) {
      const url = attributes.image.data.url;
      imageUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    } else if (attributes.image?.url) {
      const url = attributes.image.url;
      imageUrl = url.startsWith("http") ? url : `${getStrapiBaseUrl()}${url}`;
    }

    return {
      id: item.id,
      title: attributes.Title || attributes.title || attributes.name || "",
      excerpt: Array.isArray(attributes.description)
        ? attributes.description
            .map((block) =>
              block.children ? block.children.map((child) => child.text).join(" ") : ""
            )
            .join(" ")
        : attributes.description || attributes.excerpt || attributes.body || "",
      content: attributes.content || attributes.body || "",
      image: imageUrl,
      date: attributes.date || attributes.createdAt || "",
      category: attributes.category || attributes.tags || "",
      slug: attributes.slug || item.id?.toString() || "",
      readTime: attributes.readTime || "",
    };
  });
};
